<modal-popup
  [flexible]="true"
  [focusOnOpen]="focusOnOpen"
  [isOpen]="true"
  (onClose)="close()"
  [title]="'translate.general.revRuleDetails'"
  [afterTitle]="headerBtns"
  [footerTemplate]="footer"
  [isLoading]="loading"
  #modalPopup
  [alignLeft]="true" [cssClass]="detailsDialogClass"
>
  <info-details drawer [details]="drawerDetails"
    [isExpanded]="isExpanded"
    [label]="'translate.consistencyIssue.details'"
    ></info-details>
<div *ngIf="curRule">
  <div [ngClass]="{ 'rev-rule-container': isImage && isExpanded}">
    <div class="l-align-spaceBetween">
      <h3 *ngIf="curRule.similarityCode !== 'MISSING'">
        <span *ngIf="isPhrase">
          {{ "translate.general.workingPhrase" | translate }}</span
        >
        <span *ngIf="!isPhrase">
          {{ "translate.general.workingImage" | translate }}</span
        >
      </h3>
      <h3 *ngIf="curRule.similarityCode == 'MISSING'">
        {{ "translate.rev.missing" | translate }}:
      </h3>
      <p
        *ngIf="getMatchStatusCode()"
        [ngClass]="['rev-rule-status', getMatchStatusCode()]"
      >
        {{ getMatchStatusDescr() }}
      </p>
      <spinner
        *ngIf="!curRule.revStatusCode"
        class="rev-rule-status-spinner"
      ></spinner>
    </div>
    <div *ngIf="(isExpanded && isImage) && (isPotentialNew || curRule.ruleCatMatches.length == 0)"></div>
    <div *ngIf="curRule.ruleCatMatches.length > 0 && isExpanded && isImage && !isPotentialNew" class="rev-rule-navigation">
        <div class="rev-rule-nav-button-continer">
          <button *ngIf="!curRule.contextCatPhraseId" (click)="prevMatch()" class="rev-rule-nav-button rev-rule-nav-button-left">
            <i class="fas fa-arrow-left"></i>
            &nbsp;{{ (currentIndex === 0 ? 'translate.cat.last' : "translate.cat.prev") | translate }}
          </button>
        </div>
        <div class="rev-rule-current">
          <span>{{ (curRule.contextCatPhraseId ? 'translate.rev.selectedMatch' : 'translate.rev.currentMatch') | translate }}</span>
          <span *ngIf="!curRule.contextCatPhraseId">&nbsp;{{ 'translate.cat.position' | translate: {position: currentIndex + 1, totalCount: curRule.ruleCatMatches.length} }}</span>
        </div>

        <div class="rev-rule-nav-button-continer">
          <button *ngIf="!curRule.contextCatPhraseId" (click)="nextMatch()" class="rev-rule-nav-button rev-rule-nav-button-right">
            &nbsp;{{ (currentIndex === curRule.ruleCatMatches.length - 1 ? "translate.cat.first" : "translate.cat.next") | translate }}
            <i class="fas fa-arrow-right"></i>
          </button>
        </div>
    </div>

  <ng-container *ngIf="isImage">
        <div>
        <async-img
          [className]="imageClassName"
          [url]="curRule.imgUrl"
        ></async-img>
        </div>
        <div>
          <ng-container *ngTemplateOutlet="imageCatTemplate"></ng-container>
      
        </div>
        
        <ng-container *ngTemplateOutlet="consistencyIssues"></ng-container>
        <!--<div *ngIf="isExpanded"></div>-->

  </ng-container>
  </div>
      <ng-container *ngIf="curRule.associatedBy && curRule.associatedBy.length > 0">
        <div style="margin-top: 5px">
        <p class="phrase-rev-rule-ref-title">{{ "translate.general.associatedBy" | translate }}:</p>
        <p></p>
        <div *ngFor="let assocPhrase of curRule.associatedBy" class="phrase-rev-rule-ref-by-container">
          <p *ngIf="assocPhrase.phraseDispWords.length == 0" class="text">
            {{ assocPhrase.assocPhraseText }}
          </p>
          <formatted-phrase *ngIf="assocPhrase.phraseDispWords.length > 0" [phraseWords]="assocPhrase.phraseDispWords"
            class="text"></formatted-phrase>
        </div>
        </div>
      </ng-container>
  <ng-container *ngIf="isPhrase">
    <div *ngIf="curRule.revRuleType != 'BX_MATCH'">
      <p class="phrase-txt">
        <formatted-phrase
          *ngIf="isPhrase"
          [phraseWords]="curRule.ruleDispWords"
          [grammarSpellingIssues]="grammarSpellingIssues"
          [referenceIssues]="referenceIssues"
        ></formatted-phrase>



        <!-- <img *ngIf="isImage" class="ind-img" [src]="curRule.imgUrl" /> -->
      </p>
    </div>
  </ng-container>

    <div *ngIf="curRule.revRuleType == 'BX_MATCH'">
      <p class="fw-semibold">
        {{ "translate.general.boundingBox" | translate }} &middot;
        {{ curRule.boundingBoxMatch.boundingBox.boxType.text }}
      </p>
      <span> {{ curRule.boundingBoxMatch.boundingBox.descr }}</span>
    </div>

    <div
      *ngIf="isPhrase && curRule.references && !curRule.isRefSw"
      class="reference"
    >
      <p class="title">{{ "translate.rev.reference" | translate }}:</p>
      <div *ngFor="let ref of curRule.references" class="ref-container">
        <p *ngIf="ref.phraseDispWords.length == 0" class="text">
          {{ ref.refPhraseText }}
        </p>
        <formatted-phrase
          *ngIf="ref.phraseDispWords.length > 0"
          class="text"
          [phraseWords]="ref.phraseDispWords"
        ></formatted-phrase>

        <p class="ref-id">
          {{ "translate.cat.phraseId" | translate }}: {{ ref.refPhraseId }}
        </p>
      </div>
    </div>

    <div
      *ngIf="isPhrase && curRule.referencedBy && curRule.isRefSw"
      class="reference"
    >
      <p class="title">{{ "translate.rev.referencedBy" | translate }}:</p>
      <div *ngFor="let ref of curRule.referencedBy" class="ref-container">
        <p *ngIf="ref.phraseDispWords.length == 0" class="text">
          {{ ref.refPhraseText }}
        </p>
        <formatted-phrase
          *ngIf="ref.phraseDispWords.length > 0"
          [phraseWords]="ref.phraseDispWords"
          class="text"
        ></formatted-phrase>
      </div>
    </div>

    <div *ngIf="curRule.figureType" class="cat-phrase-type">
      <span>
        {{ curRule.figureTypeDescr }}
        <span *ngIf="curRule.figureSubType" class="sub-type"
          >&middot; {{ curRule.figureSubType.text }}</span
        >
      </span>
      <i  *ngIf="curRule.figureType == 'IMAGE' && imageCategoriesForDoc?.length > 0" (click)="opImageCategories.toggle($event)" class="fas fa-edit icon-edit"></i>
    </div>

    <div class="l-align-spaceBetween">
      <div class="l-align-spaceBetween">
        <p [ngClass]="['rev-rule-type-descr', curRule.revRuleType]">
          {{ curRule.revRuleSimilarityEventDesc || curRule.revRuleTypeDescr }}
        </p>
        <p class="cat-phrase-type">
          &nbsp; &middot; {{ curRule.revRuleContentTypeDesc || curRule.similarityDescr }}
        </p>
      </div>

      <p-selectButton
        *ngIf="editable"
        class="rev-status"
        [disabled]="conditionForDisablingRevStatusChanges"
        [options]="ruleStatusOptions"
        [(ngModel)]="curRule.ruleUserStatus"
        (onChange)="onRevStatusChange()"
      ></p-selectButton>
    </div>

    <div class="comment-container">
      <p class="t-footnote t-row--small">
        {{ "translate.general.comment" | translate }}
      </p>
      <textarea
        class="comment"
        tabindex="0"
        [disabled]="!editable"
        pTextarea
        [(ngModel)]="curRule.comment"
        autoResize="true"
        (blur)="checkComment()"
      ></textarea>
    </div>

    <div>
      <ng-container *ngTemplateOutlet="formatMatchTemplate"></ng-container>

      <ng-container *ngIf="!isImage">
        <ng-container *ngTemplateOutlet="catTemplate"></ng-container>
      </ng-container>

      <div *ngIf="curRule.revRuleType == 'SPELLING'">
        <ng-container *ngTemplateOutlet="spellingTemplate"></ng-container>
      </div>

      <div *ngIf="curRule.cardMatch">
        <ng-container *ngTemplateOutlet="cardMatchTemplate"></ng-container>
      </div>
    </div>

    <p class="footnote id">
      {{ "translate.rev.ruleId" | translate }}: {{ curRule.revRuleId }}
    </p>
    <!--<loader *ngIf="loading"></loader>-->
</div>
</modal-popup>

<ng-template #catTemplate>
  <ng-container *ngIf="!isPotentialNew && isExpanded && curRule.ruleCatMatches.length > 0">
    <div class="template-container" *ngFor="let match of curRule.ruleCatMatches" [ngClass]="isImage ? 'override-margin' : ''">
      <cat-match
        [match]="match" [referenceIssues]="curRule.referenceIssues"
        [displayReportMatch]="curRule.revStatusCode == 'MARKED_FOR_CHANGES'"
        (onReportDisplaySwChange)="onReportDisplaySwChange(match)"
      >
      </cat-match>
    </div>
  </ng-container>

  <div *ngIf="isPotentialNew || (!loading && curRule.ruleCatMatches.length == 0)" class="template-container">
    <h3>
      {{ "translate.rev.noMatchesFound" | translate }}
    </h3>
  </div>
</ng-template>
<ng-template #imageCatTemplate>
  <ng-container *ngIf="!isPotentialNew && isExpanded && curRule.ruleCatMatches.length > 0">
    <div class="template-container override-margin">
      <cat-match
        [match]="curRule.ruleCatMatches[currentIndex]" [displayReportMatch]="curRule.revStatusCode == 'MARKED_FOR_CHANGES'"
        (onReportDisplaySwChange)="onReportDisplaySwChange(curRule.ruleCatMatches[currentIndex])"
      >
      </cat-match>
    </div>
  </ng-container>

  <div *ngIf="isPotentialNew || (!loading && curRule.ruleCatMatches.length == 0)" class="template-container">
    <h3>
      {{ "translate.rev.noMatchesFound" | translate }}
    </h3>
  </div>
</ng-template>

<ng-template #spellingTemplate>
  <div class="template-container">
    <h3>{{ "translate.rev.suggestedFix" | translate }}</h3>
    <p class="template-phrase-txt">
      <span *ngFor="let word of curRule.ruleDiffParts">{{ word.text }}</span>
    </p>
  </div>
</ng-template>

<ng-template #cardMatchTemplate>
  <card-match [cardMatch]="curRule.cardMatch"></card-match>
</ng-template>

<ng-template #formatMatchTemplate>
  <div *ngIf="formatMatchEntry.length" class="template-container">
    <div class="l-align-spaceBetween">
      <h3>
        {{ "translate.general.formatMatch" | translate }}
      </h3>
    </div>

    <div class="template-phrase-txt">
      <formatted-phrase
        [phraseWords]="formatMatchEntry"
        [formatType]="'formatMatchEntry'"
        [formatMatchDifferences]="formatMatchDifferences"
        [highlightedIds]="highlightedIds"
        (highlightedIdsChange)="highlightDiff($event)"
      ></formatted-phrase>
    </div>

    <div class="diff-container">
      <div class="diff-title">
        <i class="fas fa-not-equal"></i>
        &nbsp; &nbsp;
        <p>{{ "translate.general.diff" | translate }}</p>
      </div>
      <p class="template-phrase-txt">
        <formatted-phrase
          [phraseWords]="formatMatchPhrase"
          [formatType]="'formatMatchPhrase'"
          [formatMatchDifferences]="formatMatchDifferences"
          [highlightedIds]="highlightedIds"
          (highlightedIdsChange)="highlightDiff($event)"
        ></formatted-phrase>
      </p>
    </div>
    <table class="diffTable">
      <thead>
        <tr>
          <th>Phrase</th>
          <th>
            <i class="fas fa-not-equal"></i>&nbsp; &nbsp;{{ "translate.general.diff" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr [class.diffRowHighlight]="isHighlighted(difference.ids)" *ngFor="let difference of formatMatchDifferences" (mouseenter)="highlightDiff(difference.ids)" (mouseleave)="clearHighlight()">
          <td><span [tooltip]="difference.text">{{ difference.text | truncate:6:'...' }}</span></td>
          <td>
            <ng-container *ngFor="let attr of difference | keyvalue">
              <div class="diffItem" *ngIf="attr.key !== 'text' && attr.key !== 'ids'">
                <span class="diffTag">{{ getFriendlyDifferenceName(attr.key) }}</span>
                <span class="diffContent" [ngSwitch]="attr.key">
                  <ng-container *ngSwitchCase="'font_size'">
                    {{ attr.value[0] }} -> {{ attr.value[1] }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'font_name'" style="font-size: 0.6em">
                    {{ getFriendlyFontName(attr.value[0]) }} -> {{ getFriendlyFontName(attr.value[1]) }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'color_hex'">
                    <span class="color-box" [tooltip]="'Hex Color Code: ' + attr.value[0]" [style.background-color]="attr.value[0]"></span> &nbsp; -> &nbsp;
                    <span class="color-box" [tooltip]="'Hex Color Code: ' + attr.value[1]" [style.background-color]="attr.value[1]"></span>
                  </ng-container>
                  <ng-container *ngSwitchDefault style="font-family: 'Arial', sans-serif; font-weight: bolder;">
                    {{ attr.value[0].toLowerCase() === 'true' ? '✓' : '✗' }} -> {{ attr.value[1].toLowerCase() === 'true' ? '✓' : '✗' }}
                  </ng-container>
                </span>
              </div>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

</ng-template>


<ng-template #headerBtns>
  <div style="display: flex; align-items: end;">
            <span 
              [ngClass]="isExpanded ? 'pi pi-angle-double-left' : 'pi pi-angle-double-right'" 
              (click)="toggle()"
              [title]="(isExpanded ? 'translate.collapse.cat-matches': 'translate.expand.cat-matches') | translate"
              style="cursor: pointer; font-size: 1.2rem;"
           ></span>
           <reeval-status-icon [target]="reevalTarget" (refresh)="onReevalRefresh()"></reeval-status-icon>
    </div>
  <div *ngIf="checkSaveChangesVisibility()" class="t-small">
    <button
      class="t-button t-button-warn"
      [disabled]="loading"
      (click)="onSaveChangesClicked()"
    >
      {{ "translate.general.saveChanges" | translate }}
    </button>
    &nbsp;
    <button
      class="t-button-outline t-button-warn"
      [disabled]="loading"
      (click)="discardChanges()"
    >
      {{ "translate.general.discardChanges" | translate }}
    </button>
  </div>
  <div class="l-align-center" *ngIf="hasPrev">
    <span [title]="('translate.prev.navigate-rules' | translate)" class="pi pi-chevron-up"(click)="showPrevRule()" style="position: absolute; 
    left: 50%; transform: translateX(-50%); color: black"></span>


  </div>
</ng-template>




<ng-template #footer>
  <div class="l-align-spaceBetween" *ngIf="hasNext"> 
    <span [title]="('translate.next.navigate-rules' | translate)" class="pi pi-chevron-down" (click)="showNextRule()"></span>


  </div>
</ng-template>
    <!--Temporary solution, probably we won't use custom endpoint for categories-->
      <p-popover #opImageCategories appendTo="body" baseZIndex="99999999999999999">
          <p-select [options]="imageCategoriesForDoc" [(ngModel)]="currentFigureCategory"
            class="l-cell-spread-x" [placeholder]="'translate.general.image-categories' | translate" [autofocus]="true"
            (onChange)="opImageCategories.hide()">
          </p-select>
      </p-popover>


    <ng-template #consistencyIssues>

          <ng-container *ngIf="curRule.consistencyIssues && curRule.consistencyIssues.length > 0">
            <div>
              <div style="display:flex; margin-top: 10px">
                <span style="margin-right: 5px" class="circle-badge error">{{ curRule.consistencyIssues.length }}</span>
                <a class="ref-title" (click)="hideClaimConsistenciesTable = !hideClaimConsistenciesTable">
                  {{ "translate.general.consistencyIssues" | translate }}
                  <span [ngClass]="hideClaimConsistenciesTable ? 'pi pi-angle-down' : 'pi pi-angle-up'"></span>
                </a>
              </div>
              <slide-in-out [isOpen]="!hideClaimConsistenciesTable">
                <div class="ref-container"
                  style="margin-top: 0.3em; height: auto !important; background-color: #fce9e8 !important; padding: 0.1em !important">
                  <consistency-issues [consistencyIssues]="curRule.consistencyIssues"
                    [element]="curRule"
                    [disableActions]="conditionForDisablingConsistencyCheckResultActions"
                    (viewConsistencyIssueEmitter)="viewConsistencyIssue($event)"
                    (removeConsistencyIssueEmitter)="removeIssueEvent()">
                  </consistency-issues>
                  <p
                    style="font-style:  italic; text-align: right; margin-right: 0.4em; margin-top: 0.2em; margin-bottom: 0.2em; color: #9d9fa2">
                    <ai-icon></ai-icon>
                  </p>
                </div>
              </slide-in-out>
            </div>
          </ng-container>
              <view-page-and-annotate-element *ngIf="showConsistencyIssuePhrases" 
                [embeddedObjectAnnotation]="currEmbeddedObjectAnnotation"
                (closePdfViewerEmitter)="showConsistencyIssuePhrases = false"></view-page-and-annotate-element>
</ng-template>